package store.actions

import it.neckar.common.redux.ChangeType
import it.neckar.lizergy.model.state.AllProcessStatesForComponents
import it.neckar.lizergy.model.state.ProcessStatesForComponent
import store.PlannerClientState

data class AllProcessStatesLoadedAction(val loadedProcessStates: List<ProcessStatesForComponent>) : StateAction {
  override val type: ChangeType = ChangeType.HistoryReset

  override fun PlannerClientState.updateState(): PlannerClientState {
    return this.copy(allProcessStatesForComponents = AllProcessStatesForComponents(this@AllProcessStatesLoadedAction.loadedProcessStates))
  }
}
